/* eslint-disable import/prefer-default-export */
/* eslint-disable guard-for-in */
import { reactive, unref, type Ref } from 'vue';

export type AccordionMode = 'single' | 'multiple';

export const useAccordionState = (mode: AccordionMode | Ref<AccordionMode> = 'single') => {
  const openIds = reactive<Record<string, boolean>>({});

  return {
    openIds,
    setOpen(id: string, value: boolean) {
      if (unref(mode) === 'multiple') {
        openIds[id] = value;
        return;
      }

      if (value) {
        for (const key of Object.keys(openIds).concat(id)) {
          const newOpen = id === key;
          if (!!openIds[key] !== newOpen) {
            openIds[key] = newOpen;
          }
        }
      } else {
        openIds[id] = value;
      }
    },
  };
};
